import * as Popover from "@radix-ui/react-popover";
import { useState, useEffect } from "react";
import Select from "@/components/molecules/Select";

const Duration = ({ value, onChange }: { value?:string, onChange: (value: string) => void }) => {
  const [hour, setHour] = useState<string>("00");
  const [minute, setMinute] = useState<string>("00");
  const [second, setSecond] = useState<string>("00");

  useEffect(() => {
    if (value) {
      const [newHour, newMinute] = value.split(":");
      setHour(newHour);
      setMinute(newMinute);
      setSecond("00");
    }
  }, [value]);

  const handleTimeChange = (updatedHour: string | null, updatedMinute: string | null, updatedSecond: string | null) => {
    if (updatedHour && updatedMinute && updatedSecond) {
      onChange(`${updatedHour}:${updatedMinute}:${updatedSecond}`);
    }
  };

  const handleHourChange = (value: string) => {
    setHour(value);
    handleTimeChange(value, minute, second);
  };

  const handleMinuteChange = (value: string) => {
    setMinute(value);
    handleTimeChange(hour, value, second);
  };

  const handleSecondChange = (value: string) => {
    setSecond(value);
    handleTimeChange(hour, minute, value);
  };

  const selectedTime =
    hour && minute && second ? `${hour}:${minute}:${second}` : "Set Duration";

  return (
    <Popover.Root>
      <Popover.Trigger className="dark:border-border px-4 py-2 rounded-md text-left border border-border">
        {selectedTime}
      </Popover.Trigger>
      <Popover.Content className="bg-background p-4 shadow-lg rounded-md">
        <div className="flex gap-4">
          {/* Saat */}
          <div>
            <label className="block text-sm font-medium">Hour</label>
            <Select
              className="dark:border-border rounded-md px-2 py-1"
              options={[...Array(24).keys()].map((hour) => ({
                label: hour.toString().padStart(2, "0"),
                value: hour.toString().padStart(2, "0"),
              }))}
              placeholder="HH"
              value={hour}
              onChange={handleHourChange}
              enabledSearch={true}
            />
          </div>

          {/* Dakika */}
          <div>
            <label className="block text-sm font-medium">Minute</label>
            <Select
              className="dark:border-border rounded-md px-2 py-1"
              options={[...Array(60).keys()].map((minute) => ({
                label: minute.toString().padStart(2, "0"),
                value: minute.toString().padStart(2, "0"),
              }))}
              placeholder="MM"
              value={minute}
              onChange={handleMinuteChange}
              enabledSearch={true}
            />
          </div>

          {/* Saniye */}
          <div>
            <label className="block text-sm font-medium">Second</label>
            <Select
              className="dark:border-border rounded-md px-2 py-1"
              options={[...Array(60).keys()].map((second) => ({
                label: second.toString().padStart(2, "0"),
                value: second.toString().padStart(2, "0"),
              }))}
              placeholder="SS"
              value={second}
              onChange={handleSecondChange}
              enabledSearch={true}
            />
          </div>
        </div>
      </Popover.Content>
    </Popover.Root>
  );
};

export default Duration;
